export default __webpack_public_path__ + "static/shark_horn-5637f054462760663a2f9160c5738545.gif";